<!--Header-->
<div class="d-flex align-content-center progress-table-row">
    <div
        class="d-flex position-sticky text-center progress-table-col progress-table-main-col flex-grow-0 bg-card"
        [class.start-0]="!isArabic"
        [class.end-0]="isArabic"
    ></div>
    @for (item of progressList(); track item.periodId) {
        <div class="d-flex progress-table-col progress-table-data-col bg-card" [dir]="languageService.direction()">
            <span class="label fw-bold text-primary" [dir]="languageService.direction()">
                {{ item.year }}
            </span>
        </div>
    }
</div>

<!--Targets-->
<div class="d-flex align-content-center progress-table-row">
    <div
        class="d-flex position-sticky text-center progress-table-col progress-table-main-col flex-grow-0"
        [class.start-0]="!isArabic"
        [class.end-0]="isArabic"
    >
        <span class="label" [dir]="languageService.direction()"> {{ "nkpi.target" | translate }} </span>
    </div>

    @for (item of progressList(); track item.periodId) {
        <div class="d-flex progress-table-col progress-table-data-col" [dir]="languageService.direction()">
            <span class="label fw-bold" [dir]="languageService.direction()">
                {{ item.target }}
            </span>
        </div>
    }
</div>

<!--Actuals-->
<div class="d-flex align-content-center progress-table-row">
    <div
        class="d-flex position-sticky text-center progress-table-col progress-table-main-col flex-grow-0"
        [class.start-0]="!isArabic"
        [class.end-0]="isArabic"
    >
        <span class="label" [dir]="languageService.direction()"> {{ "nkpi.actual" | translate }} </span>
    </div>

    @for (item of progressList(); track item.periodId) {
        <div class="d-flex progress-table-col progress-table-data-col" [dir]="languageService.direction()">
            <span class="label fw-bold" [dir]="languageService.direction()">
                {{ item.actual }}
            </span>
        </div>
    }
</div>

<!--Annual Progress-->
<div class="d-flex align-content-center progress-table-row">
    <div
        class="d-flex position-sticky text-center progress-table-col progress-table-main-col flex-grow-0"
        [class.start-0]="!isArabic"
        [class.end-0]="isArabic"
    >
        <span class="label" [dir]="languageService.direction()"> {{ "national_strategies.annual_progress" | translate }} </span>
    </div>

    @for (item of progressList(); track item.periodId) {
        <div class="d-flex progress-table-col progress-table-data-col" [dir]="languageService.direction()">
            <span class="label fw-bold" [dir]="languageService.direction()">
                {{ item.annualProgress | percentageValue: 2 : "" : "%" }}
            </span>
        </div>
    }
</div>

<!--Accumulated Progress-->
<div class="d-flex align-content-center progress-table-row">
    <div
        class="d-flex position-sticky text-center progress-table-col progress-table-main-col flex-grow-0"
        [class.start-0]="!isArabic"
        [class.end-0]="isArabic"
    >
        <span class="label" [dir]="languageService.direction()"> {{ "national_strategies.accumulated_progress" | translate }} </span>
    </div>

    @for (item of progressList(); track item.periodId) {
        <div class="d-flex progress-table-col progress-table-data-col" [dir]="languageService.direction()">
            <span class="label fw-bold" [dir]="languageService.direction()">
                {{ item.accumulatedProgress | percentageValue: 2 : "" : "%" }}
            </span>
        </div>
    }
</div>

<!--Overall Progress-->
<div class="d-flex align-content-center progress-table-row">
    <div
        class="d-flex position-sticky text-center progress-table-col progress-table-main-col flex-grow-0"
        [class.start-0]="!isArabic"
        [class.end-0]="isArabic"
    >
        <span class="label" [dir]="languageService.direction()"> {{ "national_strategies.initiative_progress" | translate }} </span>
    </div>

    @for (item of progressList(); track item.periodId) {
        <div class="d-flex progress-table-col progress-table-data-col" [dir]="languageService.direction()">
            <span class="label fw-bold" [dir]="languageService.direction()">
                {{ item.overallProgress | percentageValue: 2 : "" : "%" }}
            </span>
        </div>
    }
</div>
